<script lang="ts">
	import JsonOutput from '@atoms/JsonOutput.svelte';
	import type { FailedBlock } from '@core/tools/cms';

	let { data }: { data: FailedBlock } = $props();
</script>

<section>
	<div class="top">
		<h2>Failed validation for block with api key: "{data.targetModelApiKey}"</h2>
	</div>

	<div class="bottom">
		<h4>Message</h4>

		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		<p>{@html data.failedMessage}</p>
	</div>
	{#if data.fromCMS}
		<div>
			<h4>Provided JSON:</h4>
			<JsonOutput data={data.fromCMS} />
		</div>
	{/if}
</section>

<style>
	section {
		background-color: crimson;
		border-radius: 20px;
	}

	.top {
		border-bottom: 2px maroon solid;
	}

	.bottom {
		background-color: rgba(0, 0, 0, 0.15);
		border-radius: 0px 0px 20px 20px;
		text-align: center;
	}

	div {
		padding: 1rem;
	}

	h2 {
		font-size: 20px;
		margin: 0;
		text-align: center;
	}

	h4 {
		font-size: 12px;
		text-transform: uppercase;
		font-weight: bold;
	}

	p {
		font-size: 15px;
	}
</style>
